import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import "jquery/plugins/accessiblemegamenu/accessible.mega.menu";
import { StickyElement } from "core/classes/scroll/sticky.element";
import "jquery/EventHelpers/EventHelpers";
import "jquery/Plugins/HoverIntent/hover.intent";
import "intersection-observer";

$(window).on("wallpaper:advert", function() {
  if (!Abacus.PreventDefault.MoreDesktopNavigation) {
    $(".desktopNavigation").each(function() {
      setTimeout(() => {
        new MoreNavigation(this);
      }, 0);
    });
  }
});

$(document).ready(function() {
  if (!Abacus.PreventDefault.TwoTouchDesktopNavigation) {
    $(".desktopNavigation ul.main > li.hasChildren").each(function() {
      new TwoTouchNavigation(this);
    });
  }
  if (!Abacus.PreventDefault.DesktopNavigation) {
    $(".desktopNavigation > .inner-sleeve").accessibleMegaMenu({
      uuidPrefix: "accessible-megamenu",
      menuClass: "main",
      topNavItemClass: "nav-item",
      panelClass: "sub-nav",
      panelGroupClass: "inner-sleeve > ul > li",
      hoverClass: "hover",
      focusClass: "focus",
      openClass: "open"
    });
  }
  if (!Abacus.PreventDefault.StickyDesktopNavigation) {
    $(".desktopNavigation").each(function() {
      new StickyDesktopNavigation(this);
    });
  }
  if (!Abacus.PreventDefault.DesktopNavigationLoaded) {
    $(".desktopNavigation ul.main").removeClass("preJS");
  }
  if (!Abacus.PreventDefault.DesktopNavigationVanityPanel) {
    $(".desktopNavigation").each(function() {
      new VanityPanel(this);
    });
  }
  if (!Abacus.PreventDefault.MoreDesktopNavigation) {
    $(".desktopNavigation").each(function() {
      setTimeout(() => {
        new MoreNavigation(this);
      }, 0);
    });
  }
});

class TwoTouchNavigation extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.$a = this.element.children("a");
    if (!this.isTouch()) return;
    this.setOptions(options);
    this.setUpEvents();
  }

  isTouch() {
    return $("html").hasClass("touchevents");
  }

  setUpEvents() {
    $(this.element)
      .children("a")
      .on("click", function(evt) {
        var href;
        if (
          !$(evt.target)
            .parents("li.hasChildren")
            .hasClass("js-first-touch")
        ) {
          $(evt.target)
            .parents("li")
            .addClass("js-first-touch");
          evt.preventDefault();
        } else {
          if ($(evt.target).is("a")) {
            href = $(evt.target).attr("href");
          } else {
            href = $(evt.target)
              .parent()
              .attr("href");
          }
          window.location.href = href;
        }
      });

    $(this.element).on("outerClick", function() {
      $(".desktopNavigation ul.main > li.hasChildren").removeClass(
        "js-first-touch"
      );
    });

    this.$a.on("keydown", function(e) {
      $(this)
        .closest(".subnav")
        .focus();
      if ($(this).hasClass("open")) {
        if (e.keyCode == 13 || e.keyCode == 32) {
          var href = $(this).attr("href");
          if (href) {
            window.location.href = href;
          }
        }
      }
    });
  }
}

class MoreNavigation extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.$ul = this.element.find("ul.main");
    this.$items = this.$ul.children(":not(.more)");
    this.$more = this.$ul.children(".more");
    this.setOptions(options);
    this.setUpEvents();
    this.update();
  }

  setUpEvents() {
    var self = this;
    $(window).on("resize", function() {
      self.update();
    });
  }

  update() {
    var ulWidth = this.$ul.width(),
      moreWidth = this.$more.width(),
      widthWithMoreLink = ulWidth - moreWidth;

    this.$ul.append(this.$more);
    this.hide(this.$more);
    this.show(this.$items);

    this.hideItemsGreaterThanMax(ulWidth);

    if (this.someItemsAreHidden()) {
      this.show(this.$more);
      this.hideItemsGreaterThanMax(widthWithMoreLink);
      this.firstHiddenItem().before(this.$more);
    }
  }

  hideItemsGreaterThanMax(width) {
    var self = this,
      combinedWidth = 0;

    this.$items.each(function() {
      combinedWidth += $(this).outerWidth();
      if (combinedWidth >= width) {
        self.hide($(this));
      }
    });
  }

  someItemsAreHidden() {
    return this.$items.hasClass("hide");
  }

  firstHiddenItem() {
    return this.$items
      .filter(function() {
        return $(this).hasClass("hide");
      })
      .first();
  }

  show($item) {
    $item.removeClass("hide");
  }

  hide($item) {
    $item.addClass("hide");
  }
}

class VanityPanel extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.$hoverable = this.element.find("ul.main");
    this.$topLevelLi = this.element.find("ul.main > li");
    this.$topLevelLink = this.element.find("ul.main > li > a");
    this.$vanityPanel = this.element.find(".vanityPanel");
    this.$dropdown = this.element.find(".dropdown");

    if (this.isTouch()) return;
    this.setOptions(options);
    this.setUpEvents();
  }

  isTouch() {
    return $("html").hasClass("touchevents");
  }

  setUpEvents() {
    var self = this;
    this.$hoverable.hoverIntent(
      function() {
        self.$topLevelLi.on("mouseenter", function() {
          if ($(this).hasClass("hasChildren")) {
          }
        });
        self.$topLevelLi.on("mouseenter.vanity-panel", function() {
          if ($(this).hasClass("hasChildren")) {
            self.$vanityPanel.addClass("open");
          } else {
            self.$vanityPanel.removeClass("open");
          }
        });
      },
      function() {
        self.$vanityPanel.removeClass("open");
        self.$topLevelLi.off("mouseenter.vanity-panel");
      }
    );
    self.$topLevelLink.on('keydown', function(e){
      var previousSibling = $(this).parent().prev();
     
      if(e.shiftKey && e.key === "Tab"){       
        if(previousSibling.hasClass('hasChildren')){
          var dropdown =  previousSibling.children('.dropdown');
          dropdown.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').attr('tabindex', '-1');
            if(dropdown.hasClass('open')){
              dropdown.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').attr('tabindex', '1');
            }
         }
      }
      if(e.key === "Enter" || e.key === "ArrowDown"){
        $(this).next().find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').attr('tabindex', '1');
      }
      if(e.key==="Tab" && !e.shiftKey){
        if($(this).next().hasClass('open')){
          $(this).next().find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])').attr('tabindex', '1');
        }
      }
    })
  }
}

let StickyDesktopNavigationOptions = {
  measureElementClassName: "desktopNavigationSpace",
  bodyClass: "nav-fixed"
};

class StickyDesktopNavigation extends StickyElement {
  constructor(element, options) {
    super(element, StickyDesktopNavigationOptions);
    // used for ult cdn
    this.spacerOutOfView();
  }

  addElementMeasure() {
    this.$measure = $("." + this.options.measureElementClassName);
  }

  spacerOutOfView() {
    var mql = window.matchMedia("screen and (min-width: 1024px)");
    if (mql.matches) {
      var observer = new IntersectionObserver(entries => {
        // if out of view
        if (!entries[0].isIntersecting) {
          document.body.classList.add("measure-element-out");
        } else {
          document.body.classList.remove("measure-element-out");
        }
      });
      observer.observe(this.$measure[0]);
    }
  }
}

export { TwoTouchNavigation, MoreNavigation, VanityPanel };



// WEBPACK FOOTER //
// ./Javascript/core/classes/menu/menu.class.js